
export const URL_BASE_API   = process.env.REACT_APP_OMNI_API_URL; // import.meta.env.OMNI_API_URL; 
export const URL_IMG        = 'assets/images/';
export const LOGO_URL       = 'https://omni-prod-s3.s3.us-east-1.amazonaws.com/tascaa.png'; //'https://omni-staging-s3.s3.us-east-1.amazonaws.com/ommni_logo.png'; 
export const LOGO_DARK_URL  = 'https://omni-prod-s3.s3.us-east-1.amazonaws.com/tascaa_dark.png'; 
